import { v4 as uuidV4 } from "uuid";

import { Helpers } from "./helpers";
import { mathGuid } from "./random";

export class Guid {
    public static guid() {
        try {
            return uuidV4();
        } catch (e) {
            Helpers.sendWrapperLoadError("Error getting uuidV4");
            return mathGuid();
        }
    }

    public static guidNoDashes() {
        return uuidV4().replace(/-/g, "");
    }

    /**
     * Convert a GUID deterministically based on the passed in number
     * @param guid - guid to convert
     * @param number - a number to modify the guid by
     * @returns the modified guid or the original in case of failure
     */
    public static addNumberToGUID(guid: string, number: number) {
        // take the last 4 digits and convert to a hex string representation
        let hex = guid.slice(-4);
        let value = parseInt(hex, 16);
        if (isNaN(value)) {
            return guid;
        }
        const valLength = value.toString(16).length;
        value += number;
        // clamp to 2 bytes
        if (value > 65535) {
            value -= 65536;
        } else if (value < 0) {
            value += 65536;
        }
        // convert back to hex and make sure its as long as many digits as the initial value
        // This is needed for subtraction
        hex = value.toString(16);
        if (hex.length < valLength) {
            hex = ("00000" + hex).slice(-valLength);
        }
        // replace the last 4 digits of the guid with the last 4 digits of the converted value
        return guid.slice(0, guid.length - hex.length) + hex;
    }

    // guidHashCode takes in a String and returns a Number
    // e.g. "51c96b99-f1b0-4727-9802-a40c096929ae" => 411024693
    public static guidHashCode(guid: string) {
        let hash = 0;
        for (let i = 0; i < guid.length; i++) {
            hash += Math.pow(guid.charCodeAt(i) * 31, guid.length - i);
            hash = hash & hash; // Convert to 32bit integer
        }
        return Math.abs(hash);
    }
}
